import { useParams } from "react-router-dom";
import { useFetch } from "../lib/useData";
import { PageHero, Section, Placeholder } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1665003725647-3ae0f01140b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Legal() {
  const { slug } = useParams();
  const { data: page, loading } = useFetch(`/public/legal/${slug}`, [slug]);
  return (
    <div>
      <PageHero title={page?.title || "Legal"} image={HERO} />
      <Section className="max-w-3xl">
        {loading ? <p>Loading…</p> : <p className="text-lg text-stone-600 leading-relaxed whitespace-pre-line">{page?.content}</p>}
      </Section>
    </div>
  );
}
